// utils/authUtils.js

let jwtToken = null;  // In-memory JWT token
let csrfToken = null; // In-memory CSRF token

// Helpers
function isBadToken(token) {
  if (token === null || token === undefined) return true;
  if (typeof token !== "string") return true;
  const t = token.trim();
  return t === "" || t === "null" || t === "undefined";
}

function sanitizeStoredToken(key) {
  const t = localStorage.getItem(key);
  if (!t) return null;
  if (isBadToken(t)) {
    localStorage.removeItem(key);
    return null;
  }
  return t;
}

// ✅ Save JWT globally (memory + localStorage)
export function setJwtToken(token) {
  // If token is null/undefined/empty/"null"/"undefined" => REMOVE it (do not store "null")
  if (isBadToken(token)) {
    jwtToken = null;
    localStorage.removeItem("jwtToken");
    console.log("🗑️ JWT cleared (bad token).");
    return;
  }

  jwtToken = token.trim();
  localStorage.setItem("jwtToken", jwtToken);
  console.log("🔑 JWT saved:", jwtToken);
}

// ✅ Get JWT (prefer memory, fallback to localStorage)
export function getJwtToken() {
  if (!isBadToken(jwtToken)) {
    return jwtToken;
  }

  const stored = sanitizeStoredToken("jwtToken");
  if (stored) {
    jwtToken = stored; // cache back in memory
    // console.log("📦 Retrieved JWT from localStorage.");
    return stored;
  }

  return null;
}

// ✅ Clear JWT (logout)
export function clearJwtToken() {
  jwtToken = null;
  localStorage.removeItem("jwtToken");
  console.log("🗑️ JWT cleared.");
}

// ✅ Save CSRF globally (memory + localStorage)
export function setCsrfToken(token) {
  if (isBadToken(token)) {
    csrfToken = null;
    localStorage.removeItem("csrfToken");
    console.log("🗑️ CSRF cleared (bad token).");
    return;
  }

  csrfToken = token.trim();
  localStorage.setItem("csrfToken", csrfToken);
  console.log("🛡️ CSRF saved:", csrfToken);
}

// ✅ Get CSRF (prefer memory, fallback to localStorage)
export function getCsrfToken() {
  if (!isBadToken(csrfToken)) {
    return csrfToken;
  }

  const stored = sanitizeStoredToken("csrfToken");
  if (stored) {
    csrfToken = stored; // cache back in memory
    // console.log("📦 Retrieved CSRF from localStorage.");
    return stored;
  }

  return null;
}

// ✅ Clear CSRF (logout)
export function clearCsrfToken() {
  csrfToken = null;
  localStorage.removeItem("csrfToken");
  console.log("🗑️ CSRF cleared.");
}
